import axios from "axios";

export const getMyAppointments = async (jwtToken) => {
  let config: any = {
    method: "get",
    url:
      process.env.URL_NUTRICIONSALUDABLE_USER +
      "/pesosaludable/common/api/v2.0/appointment/list",
    headers: {
      Authorization: "Bearer " + jwtToken,
      'Apikey': process.env.APIKEY_SALUD,
    },
  };
  return axios.request(config);
};

export const cancelAppointment = async (jwtToken, appointmentId) => {
  let config: any = {
    method: "delete",
    url:
      process.env.URL_NUTRICIONSALUDABLE_USER +
      "/pesosaludable/common/api/v2.0/appointment/delete",
    headers: {
      Authorization: "Bearer " + jwtToken,
      'Apikey': process.env.APIKEY_SALUD,
    },
    data: {
      appointmentId: appointmentId,
      cancelReason: "No pago",
    },
  };
  return axios.request(config);
};
